export const ROUTES = Object.freeze({
  ROOT: '/',
  LOGIN: '/login',
  LEAVE_APPLICATIONS: '/leave-applications',
  CREATE_LEAVE_APPLICATIONS: '/create-leave-applications',
  VIEW_LEAVE_APPLICATIONS: '/view-leave-applications/:id',
  EDIT_LEAVE_APPLICATIONS: '/edit-leave-applications/:id'
});
